import { Product } from '../types';

// ============================================
// JCB CONNECTORS & FUSE BOXES
// ============================================

// JCB CONNECTORS - STANDARD SERIES
export const jcbConnectorProducts: Product[] = [
  {
    id: "jcb-conn-2p-f",
    name: "JCB Connector 2 Pole Female",
    slug: "jcb-connector-2-pole-female",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 2 pole female connector with 4mm deluxe wire. 9 inch long. Premium quality for JCB equipment.",
    partNumber: "SJCB02001",
    image: "/products/jcb-connectors/jcb-holder/SJCB02001.jpg",
    featured: true,
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches (229mm)",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "2-pole", "female"],
    applications: ["JCB Equipment", "Construction Machinery", "Agricultural Equipment"],
  },
  {
    id: "jcb-conn-2p-m",
    name: "JCB Connector 2 Pole Male",
    slug: "jcb-connector-2-pole-male",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 2 pole male connector with 4mm deluxe wire. 9 inch long.",
    partNumber: "SJCB02002",
    image: "/products/jcb-connectors/jcb-holder/SJCB02002.jpg",
    featured: true,
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Male",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "2-pole", "male"],
    applications: ["JCB Equipment", "Construction Machinery"],
  },
  {
    id: "jcb-conn-2p-f-alt1",
    name: "JCB Connector 2 Pole Female - Type 2",
    slug: "jcb-connector-2-pole-female-type2",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 2 pole female connector with 4mm deluxe wire. Alternative type 2 design.",
    partNumber: "SJCB02005",
    image: "/products/jcb-connectors/jcb-holder/SJCB02005.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Type": "Type 2",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "2-pole", "female", "type-2"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-2p-m-alt1",
    name: "JCB Connector 2 Pole Male - Type 2",
    slug: "jcb-connector-2-pole-male-type2",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 2 pole male connector with 4mm deluxe wire. Alternative type 2 design.",
    partNumber: "SJCB02006",
    image: "/products/jcb-connectors/jcb-holder/SJCB02006.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Male",
      "Type": "Type 2",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "2-pole", "male", "type-2"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-3p-f",
    name: "JCB Connector 3 Pole Female",
    slug: "jcb-connector-3-pole-female",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 3 pole female connector with 4mm deluxe wire.",
    partNumber: "SJCB03001",
    image: "/products/jcb-connectors/jcb-holder/SJCB03001.jpg",
    featured: true,
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "3-pole", "female"],
    applications: ["JCB Equipment", "Construction Machinery"],
  },
  {
    id: "jcb-conn-3p-m",
    name: "JCB Connector 3 Pole Male",
    slug: "jcb-connector-3-pole-male",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 3 pole male connector with 4mm deluxe wire.",
    partNumber: "SJCB03002",
    image: "/products/jcb-connectors/jcb-holder/SJCB03002.jpg",
    featured: true,
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Male",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "3-pole", "male"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-3p-f-alt1",
    name: "JCB Connector 3 Pole Female - Type 2",
    slug: "jcb-connector-3-pole-female-type2",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 3 pole female connector with 4mm deluxe wire. Alternative type 2.",
    partNumber: "SJCB03005",
    image: "/products/jcb-connectors/jcb-holder/SJCB03005.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Type": "Type 2",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "3-pole", "female", "type-2"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-3p-m-alt1",
    name: "JCB Connector 3 Pole Male - Type 2",
    slug: "jcb-connector-3-pole-male-type2",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 3 pole male connector with 4mm deluxe wire. Alternative type 2.",
    partNumber: "SJCB03006",
    image: "/products/jcb-connectors/jcb-holder/SJCB03006.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Male",
      "Type": "Type 2",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "3-pole", "male", "type-2"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-4p-f",
    name: "JCB Connector 4 Pole Female",
    slug: "jcb-connector-4-pole-female",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 4 pole female connector with 4mm deluxe wire.",
    partNumber: "SJCB04001",
    image: "/products/jcb-connectors/jcb-holder/SJCB04001.jpg",
    featured: true,
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "4-pole", "female"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-4p-m",
    name: "JCB Connector 4 Pole Male",
    slug: "jcb-connector-4-pole-male",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 4 pole male connector with 4mm deluxe wire.",
    partNumber: "SJCB04002",
    image: "/products/jcb-connectors/jcb-holder/SJCB04002.jpg",
    featured: true,
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Male",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "4-pole", "male"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-4p-f-alt1",
    name: "JCB Connector 4 Pole Female - Type 2",
    slug: "jcb-connector-4-pole-female-type2",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 4 pole female connector with 4mm deluxe wire. Alternative type 2.",
    partNumber: "SJCB04005",
    image: "/products/jcb-connectors/jcb-holder/SJCB04005.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Type": "Type 2",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "4-pole", "female", "type-2"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-4p-m-alt1",
    name: "JCB Connector 4 Pole Male - Type 2",
    slug: "jcb-connector-4-pole-male-type2",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 4 pole male connector with 4mm deluxe wire. Alternative type 2.",
    partNumber: "SJCB04006",
    image: "/products/jcb-connectors/jcb-holder/SJCB04006.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Male",
      "Type": "Type 2",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "4-pole", "male", "type-2"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-6p-f",
    name: "JCB Connector 6 Pole Female",
    slug: "jcb-connector-6-pole-female",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 6 pole female connector with 4mm deluxe wire.",
    partNumber: "SJCB06001",
    image: "/products/jcb-connectors/jcb-holder/SJCB06001.jpg",
    featured: true,
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Female",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "6-pole", "female"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-6p-m",
    name: "JCB Connector 6 Pole Male",
    slug: "jcb-connector-6-pole-male",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 6 pole male connector with 4mm deluxe wire.",
    partNumber: "SJCB06002",
    image: "/products/jcb-connectors/jcb-holder/SJCB06002.jpg",
    featured: true,
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Male",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "6-pole", "male"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-6p-f-alt1",
    name: "JCB Connector 6 Pole Female - Type 2",
    slug: "jcb-connector-6-pole-female-type2",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 6 pole female connector with 4mm deluxe wire. Alternative type 2.",
    partNumber: "SJCB06005",
    image: "/products/jcb-connectors/jcb-holder/SJCB06005.jpg",
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Female",
      "Type": "Type 2",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "6-pole", "female", "type-2"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-6p-m-alt1",
    name: "JCB Connector 6 Pole Male - Type 2",
    slug: "jcb-connector-6-pole-male-type2",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 6 pole male connector with 4mm deluxe wire. Alternative type 2.",
    partNumber: "SJCB06006",
    image: "/products/jcb-connectors/jcb-holder/SJCB06006.jpg",
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Male",
      "Type": "Type 2",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "6-pole", "male", "type-2"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-8p-f",
    name: "JCB Connector 8 Pole Female",
    slug: "jcb-connector-8-pole-female",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 8 pole female connector with 4mm deluxe wire.",
    partNumber: "SJCB08001",
    image: "/products/jcb-connectors/jcb-holder/SJCB08001.jpg",
    featured: true,
    specifications: {
      "Poles": "8 Pole",
      "Gender": "Female",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "8-pole", "female"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-8p-m",
    name: "JCB Connector 8 Pole Male",
    slug: "jcb-connector-8-pole-male",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 8 pole male connector with 4mm deluxe wire.",
    partNumber: "SJCB08002",
    image: "/products/jcb-connectors/jcb-holder/SJCB08002.jpg",
    featured: true,
    specifications: {
      "Poles": "8 Pole",
      "Gender": "Male",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "8-pole", "male"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-12p-f",
    name: "JCB Connector 12 Pole Female",
    slug: "jcb-connector-12-pole-female",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 12 pole female connector with 4mm deluxe wire.",
    partNumber: "SJCB12001",
    image: "/products/jcb-connectors/jcb-holder/SJCB12001.jpg",
    featured: true,
    specifications: {
      "Poles": "12 Pole",
      "Gender": "Female",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "12-pole", "female"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-12p-m",
    name: "JCB Connector 12 Pole Male",
    slug: "jcb-connector-12-pole-male",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 12 pole male connector with 4mm deluxe wire.",
    partNumber: "JSCB12002",
    featured: true,
    specifications: {
      "Poles": "12 Pole",
      "Gender": "Male",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "12-pole", "male"],
    applications: ["JCB Equipment"],
  },
];

// JCB CONNECTORS - ALTERNATIVE SERIES (WITH 5MM WIRE)
export const jcbConnectorAlternativeProducts: Product[] = [
  {
    id: "jcb-conn-2p-f-5mm",
    name: "JCB Connector 2 Pole Female - 5mm Wire",
    slug: "jcb-connector-2-pole-female-5mm",
    category: "JCB Connectors",
    subcategory: "JCB Heavy Duty Connectors",
    description: "JCB 2 pole female connector with 5mm deluxe wire. Heavy duty variant.",
    partNumber: "SJCB02013",
    image: "/products/jcb-connectors/jcb-holder/SJCB02013.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Compatible": "JCB Equipment",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "2-pole", "female", "5mm", "heavy-duty"],
    applications: ["JCB Equipment", "Heavy Duty"],
  },
  {
    id: "jcb-conn-2p-m-5mm",
    name: "JCB Connector 2 Pole Male - 5mm Wire",
    slug: "jcb-connector-2-pole-male-5mm",
    category: "JCB Connectors",
    subcategory: "JCB Heavy Duty Connectors",
    description: "JCB 2 pole male connector with 5mm deluxe wire. Heavy duty variant.",
    partNumber: "SJCB02014",
    image: "/products/jcb-connectors/jcb-holder/SJCB02014.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Male",
      "Compatible": "JCB Equipment",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "2-pole", "male", "5mm", "heavy-duty"],
    applications: ["JCB Equipment", "Heavy Duty"],
  },
  {
    id: "jcb-conn-4p-f-5mm",
    name: "JCB Connector 4 Pole Female - 5mm Wire",
    slug: "jcb-connector-4-pole-female-5mm",
    category: "JCB Connectors",
    subcategory: "JCB Heavy Duty Connectors",
    description: "JCB 4 pole female connector with 5mm deluxe wire. Heavy duty variant.",
    partNumber: "SJCB04013",
    image: "/products/jcb-connectors/jcb-holder/SJCB04013.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Compatible": "JCB Equipment",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "4-pole", "female", "5mm", "heavy-duty"],
    applications: ["JCB Equipment", "Heavy Duty"],
  },
  {
    id: "jcb-conn-4p-m-5mm",
    name: "JCB Connector 4 Pole Male - 5mm Wire",
    slug: "jcb-connector-4-pole-male-5mm",
    category: "JCB Connectors",
    subcategory: "JCB Heavy Duty Connectors",
    description: "JCB 4 pole male connector with 5mm deluxe wire. Heavy duty variant.",
    partNumber: "SJCB04014",
    image: "/products/jcb-connectors/jcb-holder/SJCB04014.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Male",
      "Compatible": "JCB Equipment",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "4-pole", "male", "5mm", "heavy-duty"],
    applications: ["JCB Equipment", "Heavy Duty"],
  },
  {
    id: "jcb-conn-2p-f-alt2",
    name: "JCB Connector 2 Pole Female - Type 3",
    slug: "jcb-connector-2-pole-female-type3",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 2 pole female connector with 4mm deluxe wire. Alternative type 3.",
    partNumber: "SJCB02009",
    image: "/products/jcb-connectors/jcb-holder/SJCB02009.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Female",
      "Type": "Type 3",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "2-pole", "female", "type-3"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-2p-m-alt2",
    name: "JCB Connector 2 Pole Male - Type 3",
    slug: "jcb-connector-2-pole-male-type3",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 2 pole male connector with 4mm deluxe wire. Alternative type 3.",
    partNumber: "SJCB02010",
    image: "/products/jcb-connectors/jcb-holder/SJCB02010.jpg",
    specifications: {
      "Poles": "2 Pole",
      "Gender": "Male",
      "Type": "Type 3",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "2-pole", "male", "type-3"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-3p-f-alt2",
    name: "JCB Connector 3 Pole Female - Type 3",
    slug: "jcb-connector-3-pole-female-type3",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 3 pole female connector with 4mm deluxe wire. Alternative type 3.",
    partNumber: "SJCB03009",
    image: "/products/jcb-connectors/jcb-holder/SJCB03009.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Female",
      "Type": "Type 3",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "3-pole", "female", "type-3"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-3p-m-alt2",
    name: "JCB Connector 3 Pole Male - Type 3",
    slug: "jcb-connector-3-pole-male-type3",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 3 pole male connector with 4mm deluxe wire. Alternative type 3.",
    partNumber: "SJCB03010",
    image: "/products/jcb-connectors/jcb-holder/SJCB03010.jpg",
    specifications: {
      "Poles": "3 Pole",
      "Gender": "Male",
      "Type": "Type 3",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "3-pole", "male", "type-3"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-4p-f-alt2",
    name: "JCB Connector 4 Pole Female - Type 3",
    slug: "jcb-connector-4-pole-female-type3",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 4 pole female connector with 4mm deluxe wire. Alternative type 3.",
    partNumber: "SJCB04009",
    image: "/products/jcb-connectors/jcb-holder/SJCB04009.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Female",
      "Type": "Type 3",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "4-pole", "female", "type-3"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-4p-m-alt2",
    name: "JCB Connector 4 Pole Male - Type 3",
    slug: "jcb-connector-4-pole-male-type3",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 4 pole male connector with 4mm deluxe wire. Alternative type 3.",
    partNumber: "SJCB04010",
    image: "/products/jcb-connectors/jcb-holder/SJCB04010.jpg",
    specifications: {
      "Poles": "4 Pole",
      "Gender": "Male",
      "Type": "Type 3",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "4-pole", "male", "type-3"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-6p-f-alt2",
    name: "JCB Connector 6 Pole Female - Type 3",
    slug: "jcb-connector-6-pole-female-type3",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 6 pole female connector with 4mm deluxe wire. Alternative type 3.",
    partNumber: "SJCB06009",
    image: "/products/jcb-connectors/jcb-holder/SJCB06009.jpg",
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Female",
      "Type": "Type 3",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "6-pole", "female", "type-3"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-6p-m-alt2",
    name: "JCB Connector 6 Pole Male - Type 3",
    slug: "jcb-connector-6-pole-male-type3",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 6 pole male connector with 4mm deluxe wire. Alternative type 3.",
    partNumber: "SJCB06010",
    image: "/products/jcb-connectors/jcb-holder/SJCB06010.jpg",
    specifications: {
      "Poles": "6 Pole",
      "Gender": "Male",
      "Type": "Type 3",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "6-pole", "male", "type-3"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-8p-f-alt1",
    name: "JCB Connector 8 Pole Female - Type 2",
    slug: "jcb-connector-8-pole-female-type2",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 8 pole female connector with 4mm deluxe wire. Alternative type 2.",
    partNumber: "SJCB08005",
    image: "/products/jcb-connectors/jcb-holder/SJCB08005.jpg",
    specifications: {
      "Poles": "8 Pole",
      "Gender": "Female",
      "Type": "Type 2",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "8-pole", "female", "type-2"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-8p-m-alt1",
    name: "JCB Connector 8 Pole Male - Type 2",
    slug: "jcb-connector-8-pole-male-type2",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 8 pole male connector with 4mm deluxe wire. Alternative type 2.",
    partNumber: "SJCB08006",
    image: "/products/jcb-connectors/jcb-holder/SJCB08006.jpg",
    specifications: {
      "Poles": "8 Pole",
      "Gender": "Male",
      "Type": "Type 2",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "8-pole", "male", "type-2"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-8p-f-alt2",
    name: "JCB Connector 8 Pole Female - Type 3",
    slug: "jcb-connector-8-pole-female-type3",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 8 pole female connector with 4mm deluxe wire. Alternative type 3.",
    partNumber: "SJCB08009",
    image: "/products/jcb-connectors/jcb-holder/SJCB08009.jpg",
    specifications: {
      "Poles": "8 Pole",
      "Gender": "Female",
      "Type": "Type 3",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "8-pole", "female", "type-3"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-8p-m-alt2",
    name: "JCB Connector 8 Pole Male - Type 3",
    slug: "jcb-connector-8-pole-male-type3",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 8 pole male connector with 4mm deluxe wire. Alternative type 3.",
    partNumber: "SJCB08010",
    image: "/products/jcb-connectors/jcb-holder/SJCB08010.jpg",
    specifications: {
      "Poles": "8 Pole",
      "Gender": "Male",
      "Type": "Type 3",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "8-pole", "male", "type-3"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-12p-f-alt1",
    name: "JCB Connector 12 Pole Female - Type 2",
    slug: "jcb-connector-12-pole-female-type2",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 12 pole female connector with 4mm deluxe wire. Alternative type 2.",
    partNumber: "SJCB12005",
    image: "/products/jcb-connectors/jcb-holder/SJCB12005.jpg",
    specifications: {
      "Poles": "12 Pole",
      "Gender": "Female",
      "Type": "Type 2",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "12-pole", "female", "type-2"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-12p-m-alt1",
    name: "JCB Connector 12 Pole Male - Type 2",
    slug: "jcb-connector-12-pole-male-type2",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 12 pole male connector with 4mm deluxe wire. Alternative type 2.",
    partNumber: "SJCB12006",
    image: "/products/jcb-connectors/jcb-holder/SJCB12006.jpg",
    specifications: {
      "Poles": "12 Pole",
      "Gender": "Male",
      "Type": "Type 2",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "12-pole", "male", "type-2"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-12p-f-alt2",
    name: "JCB Connector 12 Pole Female - Type 3",
    slug: "jcb-connector-12-pole-female-type3",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 12 pole female connector with 4mm deluxe wire. Alternative type 3.",
    partNumber: "SJCB12009",
    image: "/products/jcb-connectors/jcb-holder/SJCB12009.jpg",
    specifications: {
      "Poles": "12 Pole",
      "Gender": "Female",
      "Type": "Type 3",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "12-pole", "female", "type-3"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-12p-m-alt2",
    name: "JCB Connector 12 Pole Male - Type 3",
    slug: "jcb-connector-12-pole-male-type3",
    category: "JCB Connectors",
    subcategory: "JCB Standard Connectors",
    description: "JCB 12 pole male connector with 4mm deluxe wire. Alternative type 3.",
    partNumber: "SJCB12010",
    image: "/products/jcb-connectors/jcb-holder/SJCB12010.jpg",
    specifications: {
      "Poles": "12 Pole",
      "Gender": "Male",
      "Type": "Type 3",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "12-pole", "male", "type-3"],
    applications: ["JCB Equipment"],
  },
];

// JCB HIGH POLE COUNT CONNECTORS (9-33 POLE)
export const jcbHighPoleConnectorProducts: Product[] = [
  {
    id: "jcb-conn-9p-f",
    name: "JCB Connector 9 Pole Female",
    slug: "jcb-connector-9-pole-female",
    category: "JCB Connectors",
    subcategory: "JCB High Pole Connectors",
    description: "JCB 9 pole female connector with 4mm & 5mm deluxe wire.",
    partNumber: "SJCB00019",
    image: "/products/jcb-connectors/jcb-holder/SJCB00019.jpg",
    specifications: {
      "Poles": "9 Pole",
      "Gender": "Female",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "9-pole", "female", "high-pole"],
    applications: ["JCB Equipment", "Heavy Machinery"],
  },
  {
    id: "jcb-conn-9p-m",
    name: "JCB Connector 9 Pole Male",
    slug: "jcb-connector-9-pole-male",
    category: "JCB Connectors",
    subcategory: "JCB High Pole Connectors",
    description: "JCB 9 pole male connector with 4mm & 5mm deluxe wire.",
    partNumber: "SJCB00020",
    image: "/products/jcb-connectors/jcb-holder/SJCB00020.jpg",
    specifications: {
      "Poles": "9 Pole",
      "Gender": "Male",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "9-pole", "male", "high-pole"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-14p-f",
    name: "JCB Connector 14 Pole Female",
    slug: "jcb-connector-14-pole-female",
    category: "JCB Connectors",
    subcategory: "JCB High Pole Connectors",
    description: "JCB 14 pole female connector with 4mm & 5mm deluxe wire.",
    partNumber: "SJCB00023",
    image: "/products/jcb-connectors/jcb-holder/SJCB00023.jpg",
    featured: true,
    specifications: {
      "Poles": "14 Pole",
      "Gender": "Female",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "14-pole", "female", "high-pole"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-14p-m",
    name: "JCB Connector 14 Pole Male",
    slug: "jcb-connector-14-pole-male",
    category: "JCB Connectors",
    subcategory: "JCB High Pole Connectors",
    description: "JCB 14 pole male connector with 4mm & 5mm deluxe wire.",
    partNumber: "SJCB00024",
    image: "/products/jcb-connectors/jcb-holder/SJCB00024.jpg",
    featured: true,
    specifications: {
      "Poles": "14 Pole",
      "Gender": "Male",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "14-pole", "male", "high-pole"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-16p-f",
    name: "JCB Connector 16 Pole Female",
    slug: "jcb-connector-16-pole-female",
    category: "JCB Connectors",
    subcategory: "JCB High Pole Connectors",
    description: "JCB 16 pole female connector with 4mm & 5mm deluxe wire.",
    partNumber: "SJCB00027",
    image: "/products/jcb-connectors/jcb-holder/SJCB00027.jpg",
    featured: true,
    specifications: {
      "Poles": "16 Pole",
      "Gender": "Female",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "16-pole", "female", "high-pole"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-16p-m",
    name: "JCB Connector 16 Pole Male",
    slug: "jcb-connector-16-pole-male",
    category: "JCB Connectors",
    subcategory: "JCB High Pole Connectors",
    description: "JCB 16 pole male connector with 4mm & 5mm deluxe wire.",
    partNumber: "SJCB00028",
    image: "/products/jcb-connectors/jcb-holder/SJCB00028.jpg",
    featured: true,
    specifications: {
      "Poles": "16 Pole",
      "Gender": "Male",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "16-pole", "male", "high-pole"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-18p-f",
    name: "JCB Connector 18 Pole Female",
    slug: "jcb-connector-18-pole-female",
    category: "JCB Connectors",
    subcategory: "JCB High Pole Connectors",
    description: "JCB 18 pole female connector with 4mm & 5mm deluxe wire.",
    partNumber: "SJCB00031",
    image: "/products/jcb-connectors/jcb-holder/SJCB00031.jpg",
    featured: true,
    specifications: {
      "Poles": "18 Pole",
      "Gender": "Female",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "18-pole", "female", "high-pole"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-18p-m",
    name: "JCB Connector 18 Pole Male",
    slug: "jcb-connector-18-pole-male",
    category: "JCB Connectors",
    subcategory: "JCB High Pole Connectors",
    description: "JCB 18 pole male connector with 4mm & 5mm deluxe wire.",
    partNumber: "SJCB00032",
    image: "/products/jcb-connectors/jcb-holder/SJCB00032.jpg",
    featured: true,
    specifications: {
      "Poles": "18 Pole",
      "Gender": "Male",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "18-pole", "male", "high-pole"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-19p-f",
    name: "JCB Connector 19 Pole Female",
    slug: "jcb-connector-19-pole-female",
    category: "JCB Connectors",
    subcategory: "JCB High Pole Connectors",
    description: "JCB 19 pole female connector with 4mm & 5mm deluxe wire.",
    partNumber: "SJCB00051",
    image: "/products/jcb-connectors/jcb-holder/SJCB00051.jpg",
    specifications: {
      "Poles": "19 Pole",
      "Gender": "Female",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "19-pole", "female", "high-pole"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-21p-m",
    name: "JCB Connector 21 Pole Male",
    slug: "jcb-connector-21-pole-male",
    category: "JCB Connectors",
    subcategory: "JCB High Pole Connectors",
    description: "JCB 21 pole male connector with 4mm & 5mm deluxe wire.",
    partNumber: "SJCB00052",
    image: "/products/jcb-connectors/jcb-holder/SJCB00052.jpg",
    specifications: {
      "Poles": "21 Pole",
      "Gender": "Male",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "21-pole", "male", "high-pole"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-23p-f",
    name: "JCB Connector 23 Pole Female",
    slug: "jcb-connector-23-pole-female",
    category: "JCB Connectors",
    subcategory: "JCB High Pole Connectors",
    description: "JCB 23 pole female connector with 4mm & 5mm deluxe wire.",
    partNumber: "SJCB00035",
    image: "/products/jcb-connectors/jcb-holder/SJCB00035.jpg",
    featured: true,
    specifications: {
      "Poles": "23 Pole",
      "Gender": "Female",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "23-pole", "female", "high-pole"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-23p-m",
    name: "JCB Connector 23 Pole Male",
    slug: "jcb-connector-23-pole-male",
    category: "JCB Connectors",
    subcategory: "JCB High Pole Connectors",
    description: "JCB 23 pole male connector with 4mm & 5mm deluxe wire.",
    partNumber: "SJCB00036",
    image: "/products/jcb-connectors/jcb-holder/SJCB00036.jpg",
    featured: true,
    specifications: {
      "Poles": "23 Pole",
      "Gender": "Male",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "23-pole", "male", "high-pole"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-29p-f",
    name: "JCB Connector 29 Pole Female",
    slug: "jcb-connector-29-pole-female",
    category: "JCB Connectors",
    subcategory: "JCB High Pole Connectors",
    description: "JCB 29 pole female connector with 4mm & 5mm deluxe wire.",
    partNumber: "SJCB00039",
    image: "/products/jcb-connectors/jcb-holder/SJCB00039.jpg",
    featured: true,
    specifications: {
      "Poles": "29 Pole",
      "Gender": "Female",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "29-pole", "female", "high-pole"],
    applications: ["JCB Equipment", "Heavy Machinery"],
  },
  {
    id: "jcb-conn-29p-m",
    name: "JCB Connector 29 Pole Male",
    slug: "jcb-connector-29-pole-male",
    category: "JCB Connectors",
    subcategory: "JCB High Pole Connectors",
    description: "JCB 29 pole male connector with 4mm & 5mm deluxe wire.",
    partNumber: "SJCB00040",
    image: "/products/jcb-connectors/jcb-holder/SJCB00040.jpg",
    featured: true,
    specifications: {
      "Poles": "29 Pole",
      "Gender": "Male",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "29-pole", "male", "high-pole"],
    applications: ["JCB Equipment", "Heavy Machinery"],
  },
  {
    id: "jcb-conn-31p-f",
    name: "JCB Connector 31 Pole Female",
    slug: "jcb-connector-31-pole-female",
    category: "JCB Connectors",
    subcategory: "JCB High Pole Connectors",
    description: "JCB 31 pole female connector with 4mm & 5mm deluxe wire.",
    partNumber: "SJCB00043",
    image: "/products/jcb-connectors/jcb-holder/SJCB00043.jpg",
    featured: true,
    specifications: {
      "Poles": "31 Pole",
      "Gender": "Female",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "31-pole", "female", "high-pole"],
    applications: ["JCB Equipment", "Heavy Machinery"],
  },
  {
    id: "jcb-conn-31p-m",
    name: "JCB Connector 31 Pole Male",
    slug: "jcb-connector-31-pole-male",
    category: "JCB Connectors",
    subcategory: "JCB High Pole Connectors",
    description: "JCB 31 pole male connector with 4mm & 5mm deluxe wire.",
    partNumber: "SJCB00044",
    image: "/products/jcb-connectors/jcb-holder/SJCB00044.jpg",
    featured: true,
    specifications: {
      "Poles": "31 Pole",
      "Gender": "Male",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "31-pole", "male", "high-pole"],
    applications: ["JCB Equipment", "Heavy Machinery"],
  },
  {
    id: "jcb-conn-31p-f-alt",
    name: "JCB Connector 31 Pole Female - Type 2",
    slug: "jcb-connector-31-pole-female-type2",
    category: "JCB Connectors",
    subcategory: "JCB High Pole Connectors",
    description: "JCB 31 pole female connector with 4mm & 5mm deluxe wire. Alternative type 2.",
    partNumber: "SJCB00055",
    image: "/products/jcb-connectors/jcb-holder/SJCB00055.jpg",
    specifications: {
      "Poles": "31 Pole",
      "Gender": "Female",
      "Type": "Type 2",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "31-pole", "female", "high-pole", "type-2"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-32p-m",
    name: "JCB Connector 32 Pole Male",
    slug: "jcb-connector-32-pole-male",
    category: "JCB Connectors",
    subcategory: "JCB High Pole Connectors",
    description: "JCB 32 pole male connector with 4mm & 5mm deluxe wire.",
    partNumber: "SJCB00056",
    image: "/products/jcb-connectors/jcb-holder/SJCB00056.jpg",
    specifications: {
      "Poles": "32 Pole",
      "Gender": "Male",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "32-pole", "male", "high-pole"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-32p-f",
    name: "JCB Connector 32 Pole Female",
    slug: "jcb-connector-32-pole-female",
    category: "JCB Connectors",
    subcategory: "JCB High Pole Connectors",
    description: "JCB 32 pole female connector with 4mm & 5mm deluxe wire.",
    partNumber: "SJCB00059",
    image: "/products/jcb-connectors/jcb-holder/SJCB00059.jpg",
    specifications: {
      "Poles": "32 Pole",
      "Gender": "Female",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "32-pole", "female", "high-pole"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-33p-f",
    name: "JCB Connector 33 Pole Female",
    slug: "jcb-connector-33-pole-female",
    category: "JCB Connectors",
    subcategory: "JCB High Pole Connectors",
    description: "JCB 33 pole female connector with 4mm & 5mm deluxe wire.",
    partNumber: "SJCB00060",
    image: "/products/jcb-connectors/jcb-holder/SJCB00060.jpg",
    specifications: {
      "Poles": "33 Pole",
      "Gender": "Female",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "33-pole", "female", "high-pole"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-33p-m",
    name: "JCB Connector 33 Pole Male",
    slug: "jcb-connector-33-pole-male",
    category: "JCB Connectors",
    subcategory: "JCB High Pole Connectors",
    description: "JCB 33 pole male connector with 4mm & 5mm deluxe wire.",
    partNumber: "SJCB00063",
    image: "/products/jcb-connectors/jcb-holder/SJCB00063.jpg",
    specifications: {
      "Poles": "33 Pole",
      "Gender": "Male",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "33-pole", "male", "high-pole"],
    applications: ["JCB Equipment"],
  },
  {
    id: "jcb-conn-37p-f",
    name: "JCB Connector 37 Pole Female",
    slug: "jcb-connector-37-pole-female",
    category: "JCB Connectors",
    subcategory: "JCB High Pole Connectors",
    description: "JCB 37 pole female connector with 4mm & 5mm deluxe wire.",
    partNumber: "SJCB00064",
    image: "/products/jcb-connectors/jcb-holder/SJCB00064.jpg",
    specifications: {
      "Poles": "37 Pole",
      "Gender": "Female",
      "Compatible": "JCB Equipment",
      "Wire Type": "4mm & 5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "connector", "37-pole", "female", "high-pole"],
    applications: ["JCB Equipment", "Heavy Machinery"],
  },
];

// JCB FUSE BOXES
export const jcbFuseBoxProducts: Product[] = [
  {
    id: "jcb-fuse-box-12p-small",
    name: "JCB 12 Pole Female Small Fuse Box",
    slug: "jcb-fuse-box-12-pole-small",
    category: "JCB Connectors",
    subcategory: "JCB Fuse Box",
    description: "JCB 12 pole female small fuse box with stick and 5mm deluxe wire. 9 inch long wire.",
    partNumber: "SJCB00001",
    image: "/products/jcb-connectors/jcb-holder/SJCB00001.jpg",
    featured: true,
    specifications: {
      "Type": "Small Fuse Box",
      "Poles": "12 Pole",
      "Gender": "Female",
      "Compatible": "JCB Equipment",
      "Features": "With Stick",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "9 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "fuse-box", "12-pole", "small", "stick"],
    applications: ["JCB Equipment", "Construction Machinery"],
  },
  {
    id: "jcb-fuse-box-28p-medium",
    name: "JCB 28 Pole Female Medium Fuse Box",
    slug: "jcb-fuse-box-28-pole-medium",
    category: "JCB Connectors",
    subcategory: "JCB Fuse Box",
    description: "JCB 28 pole female medium fuse box with stick and 5mm deluxe wire. 15 inch long wire.",
    partNumber: "SJCB00011",
    image: "/products/jcb-connectors/jcb-holder/SJCB00011.jpg",
    featured: true,
    specifications: {
      "Type": "Medium Fuse Box",
      "Poles": "28 Pole",
      "Gender": "Female",
      "Compatible": "JCB Equipment",
      "Features": "With Stick",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "15 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "fuse-box", "28-pole", "medium", "stick"],
    applications: ["JCB Equipment", "Heavy Machinery"],
  },
  {
    id: "jcb-fuse-box-48p-big",
    name: "JCB 48 Pole Female Big Fuse Box",
    slug: "jcb-fuse-box-48-pole-big",
    category: "JCB Connectors",
    subcategory: "JCB Fuse Box",
    description: "JCB 48 pole female big fuse box with 5mm deluxe wire. 15 inch long wire. Largest JCB fuse box.",
    partNumber: "SJCB00021",
    image: "/products/jcb-connectors/jcb-holder/SJCB00021.jpg",
    featured: true,
    specifications: {
      "Type": "Big Fuse Box",
      "Poles": "48 Pole",
      "Gender": "Female",
      "Compatible": "JCB Equipment",
      "Wire Type": "5mm Deluxe",
      "Wire Length": "15 inches",
      "Packing": "10 Pcs",
    },
    tags: ["jcb", "fuse-box", "48-pole", "big", "heavy-duty"],
    applications: ["JCB Equipment", "Heavy Construction Machinery"],
  },
];
